import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import './../financial.scss';
import financialSquare from './../../assets/images/financial-shapes-square.svg';
import financialCircle from './../../assets/images/financial-shapes-circle.svg';
import financialTriangle from './../../assets/images/financial-shapes-triangle.svg';
import AOS from "aos";
import { gsap, TimelineMax } from 'gsap';
import "aos/dist/aos.css";

export default function FinancialUsage() {

  const squareRef = useRef();
  const triangle1Ref = useRef();
  const triangle2Ref = useRef();

  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {

    document.addEventListener('aos:in:bar-anim', function(ev) {
      //console.log('animated in', ev);
      //console.log(ev.detail);

      if (ev.detail.querySelectorAll('.progress').length > 1) {
        //console.log("more than 1 progress");
        var barArray = [...ev.detail.querySelectorAll('.progress')];
      } else {
        //console.log("less than 1 progress");
        var barArray = [];
        var bar = ev.detail.querySelector('.progress');
        //console.log(bar);
        barArray.push(bar);
      }

      //console.log(barArray);

      if (barArray && barArray.length) {
        barArray.forEach(function(barItem) {

          var fill = barItem.getAttribute('data-fill');

          if (ev.detail.classList.contains('vertical-bar-chart')) {
            barItem.style.height = fill + '%';
          }

          if (!ev.detail.classList.contains('vertical-bar-chart')) {
            barItem.style.width = fill + '%';
          }
          
        });
      }

      var Cont={val:0};

      if (ev.detail.querySelectorAll('.percentage').length > 1) {
        var percentageArray = [...ev.detail.querySelectorAll('.percentage')];
        //console.log("more than 1 percentage");
      } else {
        var percentageArray = [];
        var percentage = ev.detail.children[0].querySelector('.percentage');
        percentageArray.push(percentage);
        //console.log("less than percentage");

      }

      //console.log(percentage);

      if (percentageArray) {
        percentageArray.forEach(function(percentage) {
          var percent = percentage.getAttribute('data-to');
            gsap.to(Cont,1,{val:percent,roundProps:"val",onUpdate:function(){
              percentage.textContent = Cont.val;
            },
            ease: "none"});
          
        });
      }

      //console.log(percentageArray);

    });

    document.addEventListener('aos:in:percentage', function(ev) {
      var Cont={val:0};
      var percentage = ev.detail.children[0].querySelector('.percentage');
      var percentageArray = [];
      percentageArray.push(percentage);
      //console.log(percentage);

      if (percentage) {
        percentageArray.forEach(function(percentage) {
          var percent = percentage.getAttribute('data-to');
            gsap.to(Cont,1,{val:percent,roundProps:"val",onUpdate:function(){
              percentage.textContent = Cont.val;
            },
            ease: "none"});
          
        });
      }
    });

    // Had to make some adjustments since it seemed like the animation wasn't playing nice with React. The shapes weren't incrementing exactly 90 degrees (it was adding a few degrees with decimal places) so they always rotated crooked. Possibly React strict mode causing issues. Added gsap.context, refs, and using GSAP's ScrollTrigger instead of AOS. 
    let ctx = gsap.context(() => {

      var tl = gsap.timeline({ 
        onComplete:rotateAgain,
        scrollTrigger: {
          trigger: ".shape-images"
        }
      });

      function animate(){
        tl
        .to(squareRef.current, 0.5, {rotation:"+=90"})
        .to(triangle1Ref.current, 0.5, {rotation:"+=90"}, "+=2")
        .to(triangle2Ref.current, 0.5, {rotation:"+=90"}, "+=2")
      }

      function rotateAgain(){
        gsap.delayedCall(5, animate)
      }

      animate();

    });

    return () => ctx.revert(); // <- cleanup!

    AOS.init({
      once: true
    });

    AOS.refresh();

  }, []);

  return (
    <>
      <div className="financial-usage">

        <p id="s1" className="intro" data-aos="fade-up">Explore the data and discover how companies in the financial industry are making use of direct mail.&#8288;<a href="#reference-1" class="cm-article-content__reference" aria-label="Footnote 1" title="Footnote 1"><sup aria-hidden="true">[1]</sup></a></p>
        <div className='two-cols'>
          <div className='col-left'>
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Marketing Effectiveness</h3>

                <p className="pull-quote"><span data-aos className='highlighter'>82%</span> of financial businesses find direct mail <span data-aos className='highlighter'>effective.</span></p>

                <p>Financial companies find direct mail to be more effective or as effective as other marketing channels, with the exception of social media by just 1%.</p>

                <p>Overall, financial businesses consider social the most effective marketing channel.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>No matter what channels you use, creating consistency—in voice, tone, visuals and overall identity—will lead to more effective marketing. Consistency fosters familiarity and creates a better customer experience, helping keep your brand top of mind.</p>
              </div>
            </div>

            <div className='inner-cols'>
              <div className='inner-col-item'>
                <div className='personalized-box align-to-text'>
                  <h3>Personalization is the most popular mail technique among financial companies.</h3>

                  <div className='shape-images'>
                    <div id="square" className='square'>
                      <img ref={squareRef} src={financialSquare} alt="" />
                    </div>
                    <div id="circle" className='circle'>
                      <img src={financialCircle} alt="" />
                    </div>
                    <div id="triangle1" className='triangle triangle-1'>
                      <img ref={triangle1Ref} src={financialTriangle} alt="" />
                    </div>
                    <div id="triangle2" className='triangle triangle-2'>
                      <img ref={triangle2Ref} src={financialTriangle} alt="" />
                    </div>
                  </div>

                </div>

                <div className='rounded-box-module-wrap'>
                  <div className="rounded-box-module" data-aos="fade-up">
                    <h3>Direct Mail Techniques</h3>
                    <div className='progress-bar' data-aos="horz-bar-chart" data-aos-id="bar-anim">
                      <div className='progress' data-fill="62"><span class="percentage" data-to="62" aria-hidden="true">0</span><span class="screen-reader-text">62</span>%</div>
                    </div>
                    <p>Personalized offers</p>
                    <p><strong>59%</strong> — Personalized greetings or customer names</p>
                    <p>Among financial companies, personalization is the most used direct mail technique.</p>
                  </div>
                  <div className="rounded-box-module">
                    <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                    <p>Personalized direct mail can help you maintain meaningful customer relationships. Do some segments show interest in certain savings accounts? Do you have a growing number of Gen X borrowers? Explore how you can address these segments’ varying needs, wants and values, and customize messaging accordingly.</p>
                  </div>
                </div>
              </div>
              <div className='inner-col-item'>

                <div className='rounded-box-module-wrap'>
                  <div className="rounded-box-module" data-aos="fade-up">
                    <h3>Importance of Direct Mail</h3>
                    <div className='pie-chart' data-aos>
                      <svg viewBox="0 0 32 32" role="img" alt="" title="">
                        <circle r="16" cx="16" cy="16" strokeDasharray="0 100"></circle>
                      </svg>
                    </div>

                    <span data-aos data-aos-id="percentage" data-aos-anchor=".pie-chart">
                      <span data-aos className='percentage-value'><span class="percentage" data-to="88" aria-hidden="true">0</span><span class="screen-reader-text">88</span>%</span>
                    </span>

                    <p> of financial companies say that direct mail is very important or extremely important to their business.</p>
                  </div>
                  <div className="rounded-box-module">
                    <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                    <p>Direct mail can be a powerful marketing channel in omnichannel marketing, adding a uniquely tactile, more “human” element to digital-heavy campaigns. <Link to="/financial/integration">Jump to the Integration section</Link> to learn how financial brands incorporate mail into their marketing efforts.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-right'>
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Direct Mail vs. <br />Digital Security</h3>
                <div className='progress-bar' data-aos="horz-bar-chart" data-aos-id="bar-anim">
                  <div className='progress' data-fill="57"><span class="percentage" data-to="57" aria-hidden="true">0</span><span class="screen-reader-text">57</span>%</div>
                </div>
                <p id="s2">of consumers say that direct mail feels more secure than online communications.&#8288;<a href="#reference-2" className="cm-article-content__reference" aria-label="Footnote 2" title="Footnote 2"><sup aria-hidden="true">[2]</sup></a></p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>Use these consumer perceptions to your advantage. Thoughtful, clear and <a href="/../why-personalization-may-help-you-win-with-millennials/">personalized mail messaging</a> can build trust among customers—especially important for sensitive financial messaging. Making note of your brand’s security and privacy practices can also instill confidence.</p>
              </div>
            </div>
            
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Direct Mail and the Customer Journey</h3>

                <div className='progress-bar-area vertical-bar-chart' data-aos data-aos-id="bar-anim" data-aos-offset="300">
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress fill-light' data-fill="22"><span class="percentage" data-to="22" aria-hidden="true">0</span><span class="screen-reader-text">22</span>%</div>
                    </div>
                    <span className='label'>Drive awareness</span>
                  </div>
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress' data-fill="33"><span class="percentage" data-to="33" aria-hidden="true">0</span><span class="screen-reader-text">33</span>%</div>
                    </div>
                    <span className='label'>Drive growth</span>
                  </div>
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress fill-light' data-fill="14"><span class="percentage" data-to="14" aria-hidden="true">0</span><span class="screen-reader-text">14</span>%</div>
                    </div>
                    <span className='label'>Drive leads</span>
                  </div>
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress fill-light' data-fill="31"><span class="percentage" data-to="31" aria-hidden="true">0</span><span class="screen-reader-text">31</span>%</div>
                    </div>
                    <span className='label'>Drive loyalty</span>
                  </div>
                </div>

                <p>In relation to the customer journey, most financial companies use direct mail to drive growth or loyalty.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p> To drive growth through direct mail, create messaging that speaks directly to customers’ wants and needs, using data to inform any offers and messaging you send: Higher-income customers may be interested in a travel-rewards-based credit card, while lower-income customers may be interested in payment-plan offerings.</p>
              </div>
            </div>
          </div>
        </div>



      </div>
    </>
  );
}
